<!--
 * @Author: Niklaus
 * @Date: 2026-04-27 09:56:55
 * @LastEditTime: 2026-05-08 11:40:31
 * @LastEditors: Niklaus
 * @Description: 繁星空间房间管理- G座12层1206及17层
-->
<template>
    <div>
        <el-card class="mar-t-15" v-for="item in space" :key="item.id">
            <el-row>
                <el-col :span="2">
                    <span class="spaceCard text-center pad-r-10">
                        <p class="fts-16">
                            <i class="el-icon-edit cur-p "></i>
                            {{ item.name }}
                            <small>
                                <span class="text">地上</span>
                            </small>
                        </p>
                        <!-- <el-button icon="el-icon-plus" class="addbtn fts-12" @click="addRoom(space.floor, i)">新增房间
                        </el-button> -->
                    </span>
                </el-col>
                <el-col :span="22">
                    <el-row>
                        <el-col :span="3" v-for="room in item.rooms" :key="room.id">
                            <div class="roomClazz">
                                <div class="spaceCard pad-l-10 pad-r-10  cardBg  cur-p p-r" style="width: 100%;">
                                    <span class="dropclazz" @click.stop>
                                        <el-dropdown trigger="click">
                                            <span class="el-dropdown-link">
                                                <i class="el-icon-more el-icon--right"></i>
                                            </span>
                                            <el-dropdown-menu slot="dropdown">
                                                <el-dropdown-item icon="el-icon-document-copy"
                                                    @click.native="splitRoom(room)">房间拆分</el-dropdown-item>
                                                <el-dropdown-item icon="el-icon-delete" :disabled="room.son_num > 0"
                                                    @click.native="cancle(room)">作废</el-dropdown-item>
                                            </el-dropdown-menu>
                                        </el-dropdown>
                                    </span>
                                    <div class="fts-16 mar-t-15 mar-b-10 titleclazz">
                                        {{ room.room_name }}
                                    </div>

                                    <el-tooltip v-if="room.company_name" :content="room.company_name" placement="top">
                                        <div class="fts-12">
                                            {{ room.room_area || "-" }} m²
                                        </div>
                                    </el-tooltip>
                                    <div class="fts-12" v-else>
                                        {{ room.room_area || "-" }} m²
                                    </div>
                                    <div class="fts-12 mar-t-15 mar-b-10">
                                        <div class="sonroom" v-if="room.son_num > 0">
                                            子房间({{ room.son_num }})
                                        </div>
                                        <span class="pull-right" :class="{
                                            'cz-wz': room.status == 0,
                                            'cz-yz': room.status == 1,
                                            'cz-ys': room.status == 2,
                                            'cz-zy': room.status == 3,
                                        }">{{ roomStatusList[Number(room.status)].dictValue }}</span>
                                    </div>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
        </el-card>

        <el-drawer :visible.sync="detailDia" size="40%" :withHeader="false" destroy-on-close :wrapperClosable="false">
            <el-header class="bor-b" height="50px">
                <el-page-header class="lh-50" :content="title"></el-page-header>
            </el-header>
            <el-container style="height: calc(100% - 100px)" class="o-a">
                <splitRoom :ruleFormObj="ruleForm" :floors="[]" @close="detailDia = false" ref="saveSplitRoom">
                </splitRoom>
            </el-container>
            <el-footer class="bor-t lh-49" height="50px">
                <div class="pull-right">
                    <template>
                        <el-button size="small" type="primary" @click="saveSplitRoom">保存</el-button>
                        <el-button size="small" type="" @click="detailDia = false">取消</el-button>
                    </template>
                </div>
            </el-footer>
        </el-drawer>
    </div>

</template>

<script>
import { getMetaCommonList, updateMetaCommon } from '@/api/busiMode/metaCommon'
import { getDictionary } from '@/api/system/dictbiz'
import roomInfo from './../build/space/roomInfo';
import splitRoom from './../build/space/splitRoom';

export default {
    name: 'Room',
    components: { roomInfo, splitRoom },
    data() {
        return {
            params: {
                size: 500,
                orders: [{ field: 'room_name', sort: 'ASC' }],
                wheres: [
                    { field: 'parent_id', value: 0 },
                    { field: 'is_cancel', value: 0 },
                    { field: 'building_id', value: '1619244809424257025' },
                    { field: 'floor_id', op: 'IN', value: ['1619244811454300162', '1619244812171526146'] }
                ],
            },
            space: [
                { id: '1619244811454300162', name: '12层', rooms: [] },
                { id: '1619244812171526146', name: '17层', rooms: [] }
            ],
            ruleForm: { label: [] },
            title: '',
            roomStatusList: [],
            detailDia: false
        }
    },

    created() {
        this.getDict()
        this.initData()
    },

    methods: {

        initData() {
            getMetaCommonList('wisdom_park.v_wp_room_stat', this.params).then(res => {
                console.log(res)
                res.data.data.records.forEach(e => {
                    if (e.floor_id == '1619244811454300162') {
                        if (e.room_name == '1206') this.space[0].rooms.push(e)
                    } else {
                        this.space[1].rooms.push(e)
                    }
                });
            })
        },

        getDict() {
            getDictionary({ code: 'RoomStatus' }).then(res => {
                console.log("------------------------")
                console.log(res)
                this.roomStatusList = res.data.data
            })
        },

        cancle(room) {
            this.$confirm('是否作废?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                let r = {
                    is_cancel: 1,
                    id: room.room_id,
                };
                let o = {
                    update: JSON.parse(JSON.stringify(r)),
                    primaryKeyValue: room.room_id,
                    primaryKey: 'id',
                };
                updateMetaCommon(this.model, o).then(res => {
                    if (res.data.code == 200) {
                        this.$message({
                            type: 'success',
                            message: '操作成功!',
                        });
                        this.onLoad(this.page);
                    }
                });
            });
        },
        splitRoom(room) {
            this.title = room.name || room.room_name;
            this.detailDia = true;
            this.ruleForm = room;
        },

        saveSplitRoom() {
            this.$refs.saveSplitRoom.saveRooms();
        },

    },
}
</script>

<style lang="scss" scoped>
.titleclazz {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.configInput {
    position: relative;
    font-size: 14px;
    display: inline-block;
    width: 80px;
    margin: 0px 5px;
}

.card {
    padding: 0px 10px 10px 0px;
}

ul,
li {
    list-style: none;
    margin-bottom: 5px;
}

.spaceCard {
    display: inline-block;
    min-width: 100px;
    height: 105px;
}

.cardBg {
    background: #f5f7fa;
    margin-bottom: 15px;
}

.spaceCard {
    &:hover {
        .addbtn {
            display: block;
        }
    }
}

.addbtn {
    border: 1px dotted #1976d3;
    padding: 5px 10px;
    color: #1976d3;
    margin-bottom: 10px;
    border-radius: 0px;
}

.roomClazz {
    white-space: nowrap;
    font-size: 0px;
    overflow-x: auto;
    width: 100%;
}

/deep/ .el-dialog__header {
    border-bottom: 1px solid #ebebeb;
    padding-bottom: 20px;
}

.b-b {
    border-bottom: 1px solid #dcdfe6;
}

.dropclazz {
    position: absolute;
    right: 5px;
    top: 5px;
    padding: 3px 5px 3px 0px;
    transform: rotate(-90deg);
}

.p-r {
    position: relative;
}

/deep/ .el-drawer__header {
    border-bottom: 1px solid #ebebeb;
    padding: 10px 20px;
    margin-bottom: 0px;
}

/deep/ .el-drawer__body {
    padding: 0px;
}

/deep/.el-dialog__body {
    height: calc(80vh - 110px);
    overflow: auto;
    padding: 15px;
}

.cz-yz {
    padding: 2px 9px;
    border-radius: 4px;
    margin-top: -2px;
    background: rgb(243, 207, 153);
    color: #fff;
}

.cz-wz {
    background: rgb(211, 246, 145);
    padding: 2px 9px;
    border-radius: 4px;
    margin-top: -2px;
}

.cz-ys {
    background: rgb(220, 94, 82);
    padding: 2px 9px;
    border-radius: 4px;
    margin-top: -2px;
    color: #fff;
}

.cz-zy {
    background: #90bdf0;
    padding: 2px 9px;
    border-radius: 4px;
    margin-top: -2px;
    color: #fff;
}

.sonroom {
    position: absolute;
    right: 10px;
    bottom: 40px;
    color: #1976d3;
}
</style>